/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//--------- Paypal Popup JS 
document.addEventListener('DOMContentLoaded', function () {
  
    const paypalInstallmentBar = document.querySelector('.paypal_installment_bar');
    const paypal_popup_close = document.querySelector('.paypal_popup_close');
    const paypal_popup_overlay = document.querySelector('.paypal_popup_overlay');
    if (paypalInstallmentBar) {
        paypalInstallmentBar.addEventListener('click', function () {
          const paypalInstallmentPopup = document.querySelector('.paypal_installment_popup');
          paypalInstallmentPopup.classList.add('active');
        });
    }
    if (paypal_popup_close) {
        paypal_popup_close.addEventListener('click', function () {
          const paypalInstallmentPopup = document.querySelector('.paypal_installment_popup');
          paypalInstallmentPopup.classList.remove('active');
        });
    }
    if (paypal_popup_overlay) {
        paypal_popup_overlay.addEventListener('click', function () {
          const paypalInstallmentPopup = document.querySelector('.paypal_installment_popup');
          paypalInstallmentPopup.classList.remove('active');
        });
    }

        //--------------------- product Variant Popup ---------------------
        var variant_popup_main = document.querySelector(".product_variant_popup_main");
        if(variant_popup_main){
                document.querySelectorAll(".pdp_variant_popup_close").forEach(button => {
                    button.addEventListener("click", function () {
                      let parentPopup = this.closest(".pdp_variant_popup");
                      if (parentPopup) {
                          parentPopup.classList.remove("active_popup");
                      }
                      document.querySelector('.pdp_variant_popup_overlay').style.display = 'none';
                    });
                });
        
                document.querySelector(".pdp_variant_popup_overlay").addEventListener("click", function () {
                  document.querySelector(".pdp_variant_popup.active_popup").classList.remove("active_popup");
                  this.style.display = 'none';
                });
              
                document.querySelectorAll(".varint_popup_label").forEach(label => {
                    label.addEventListener("click", function () {
                        document.querySelector('.pdp_variant_popup').classList.add("active_popup");
                        document.querySelector('.pdp_variant_popup_overlay').style.display = 'block';
                    });
                });
        
                document.querySelectorAll(".varint_popup_item").forEach(item => {
                    item.addEventListener("click", function () {
                      
                        let parentPopup = this.closest(".pdp_variant_option");
                        let selectedItem = parentPopup.querySelector(".varint_popup_item.selected");
                        if (selectedItem) {
                            selectedItem.classList.remove("selected");
                        }
                        this.classList.add("selected");
                      
                        let targetElement = document.querySelector(`.block-swatch__item[title="${this.getAttribute('option_value')}"]`);
                        if (targetElement) {
                            targetElement.click();
                        }
                      
                        if (parentPopup) {
                            let popupId = parentPopup.getAttribute("popup");
                            let labelElement = document.querySelector(`.varint_popup_label[popup="${popupId}"] .varint_popup_selected_name`);
                            
                            if (labelElement) {
                                labelElement.innerHTML = this.getAttribute("option_value");
                            }
                        }
                    });
                });
        
                document.querySelectorAll(".varint_popup_item_n").forEach(item => {
                    item.addEventListener("click", function () {
                      
                        let parentPopup = this.closest(".pdp_variant_option");
                        let selectedItem = parentPopup.querySelector(".varint_popup_item_n.selected");
                        if (selectedItem) {
                            selectedItem.classList.remove("selected");
                        }
                        this.classList.add("selected");
                      
                        let targetElement = document.querySelector(`.block-swatch__item[title="${this.getAttribute('option_value')}"]`);
                        if (targetElement) {
                            targetElement.click();
                        }
                      
                        if (parentPopup) {
                            let popupId = parentPopup.getAttribute("popup");
                            let labelElement = document.querySelector(`.varint_popup_label[popup="${popupId}"] .varint_popup_selected_name`);
                            
                            if (labelElement) {
                                labelElement.innerHTML = this.getAttribute("option_value");
                            }
                        }
                    });
                });
        }
  
});

function updateCartQuantity(selectElement) {
    var newQuantity = parseInt(selectElement.value);
    var lineItemId = parseInt(selectElement.getAttribute('data_id'));

    const data = {
        updates: {
            [lineItemId]: newQuantity
        }
    };

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(cart => {
        //console.log("Cart updated successfully:", cart);
        // Dispatch a custom event to refresh the cart
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        }));
    })
    .catch((error) => {
        console.error("Error updating cart:", error);
    });
}

document.addEventListener("DOMContentLoaded", function() {
  // Cache references for elements used in multiple places
  //const freeShippingBar = document.querySelector('.free_shipping_bar');
  const miniCartElement = document.getElementById('mini-cart');
  
  // Helper function to fetch cart data
  function fetchCartData() {
    return fetch('/cart.js')
      .then(response => response.json())
      .catch(error => {
        console.error('Error fetching cart data:', error);
        throw error;
      });
  }

  // Helper function to update the cart
  function updateCart(updates) {
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
      .then(response => response.json())
      .catch((error) => {
        console.error('Error updating the cart:', error);
        throw error;
      });
  }

  // Helper function to add product to the cart
  function addToCart(productId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: 1,
        id: productId
      })
    })
      .then(response => response.json())
      .catch((error) => {
        console.error('Error adding product to cart:', error);
        throw error;
      });
  }

  // Helper function to remove products from the cart
  function removeFromCart(productIds) {
    let updates = {};
    productIds.forEach(id => updates[id] = 0);
    return updateCart(updates);
  }

  // MutationObserver to detect changes in mini-cart
  const observer = new MutationObserver(mutationsList => {
    mutationsList.forEach(mutation => {
      if (mutation.type === 'childList') {
        setTimeout(() => {
                    const freeShippingBar = document.querySelector('.body_variant_b .free_shipping_bar');
                    if(freeShippingBar){
                    const productThreshold1 = freeShippingBar.getAttribute('product_thersold_1');
                    const productId1 = freeShippingBar.getAttribute('product_id_1');
                    const productThreshold2 = freeShippingBar.getAttribute('product_thersold_2');
                    const productId2 = freeShippingBar.getAttribute('product_id_2');
          
                    if (!productId1 && !productId2) return;
          
                     console.log('running...');
          
                    fetchCartData().then(cart => {
                      //console.log(cart);
                      const cartTotal = cart.total_price;
                      let product1Available = true;
                      let product2Available = true;
          
                      // Handle product 2 logic
                      if (cartTotal > productThreshold2 && productId2) {
                        cart.items.forEach(item => {
                          if (item.variant_id == productId1) {
                            let updates = {};
                            updates[item.variant_id] = 0;
                            updateCart(updates).then(() => {
                              console.log('Product 1 removed.')
                              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                            });
                          }
                          if (item.variant_id == productId2) {
                            product2Available = false;
                          }
                        });
                        if (product2Available) {
                          addToCart(productId2).then(() => {
                            console.log('Product 2 added.');
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                          });
                        }
                      }
          
                      // Handle product 1 logic
                      if (cartTotal > productThreshold1 && productId1) {
                        console.log('triggered');
                        cart.items.forEach(item => {
                          if (item.variant_id == productId1) {
                            product1Available = false;
                          }
                          if (item.variant_id == productId2) {
                            if(cartTotal > productThreshold2){
                               product1Available = false; 
                            }else{
                                let updates = {};
                                updates[item.variant_id] = 0;
                                updateCart(updates).then(() => {
                                  console.log('Product 2 removed.')
                                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                                });
                            }
                          }
                        });
                        if (product1Available) {
                          addToCart(productId1).then(() => {
                            console.log('Product 1 added.');
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                          });
                        }
                      }
          
                      // Handle both products removal
                      else {
                        let productIdsToRemove = [];
                        cart.items.forEach(item => {
                          if (item.variant_id == productId1 || item.variant_id == productId2) {
                            productIdsToRemove.push(item.variant_id);
                          }
                        });
                        if (productIdsToRemove.length > 0) {
                          removeFromCart(productIdsToRemove).then(() => {
                            console.log('Products removed from cart.');
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                          });
                        }
                      }
                    });
                    }
        }, 400);
      }
    });
  });

  // Set up the observer for the mini-cart
  if (miniCartElement) {
    const config = { attributes: true, childList: true, subtree: true };
    observer.observe(miniCartElement, config);
  }

  //-------------------------------- Collection Page Redesign ------------------------------------
  document.addEventListener('click', function(event) {
    if (event.target.closest('.collection__filter-group-btn')) {
      document.querySelectorAll('.collection__filter-group-btn').forEach(function(button) {
          const filterGroup = button.closest('.collection_horizontal_filter-group');
          if (filterGroup) {
            filterGroup.classList.remove('active_filter');
          }
      });
      const button = event.target.closest('.collection__filter-group-btn');
      const filterGroup = button.closest('.collection_horizontal_filter-group');
      if (filterGroup) {
        filterGroup.classList.toggle('active_filter');
      }
    }else{
      document.querySelectorAll('.collection__filter-group-btn').forEach(function(button) {
          const filterGroup = button.closest('.collection_horizontal_filter-group');
          if (filterGroup) {
            filterGroup.classList.remove('active_filter');
          }
      });
    }
  });
  //-------------------------------- Collection Page Redesign ------------------------------------

  // PDP quantity append to buy buttons
  const moveQuantityInterval = setInterval(() => {
    const quantityContainer = document.querySelector('#buy_quantity');
    const quantityElement = document.querySelector('.product-form__info-item--quantity');

    if (quantityContainer && quantityElement) {
      quantityContainer.appendChild(quantityElement);
      clearInterval(moveQuantityInterval);
    }
  }, 200);

  const interval = setInterval(() => {
    const amountEl = document.querySelector('#cashback-amount');
    const headingEl = document.querySelector('.cashback-heading');
  
    if (amountEl && amountEl.textContent.trim() !== '' && headingEl) {
      const amountText = amountEl.textContent.trim();
  
      if (!headingEl.textContent.startsWith(amountText)) {
        headingEl.textContent = `${amountText} ${headingEl.textContent.trim()}`;
      }
  
      clearInterval(interval);
    }
  }, 500);


});

document.addEventListener('click', function (event) {
  if (event.target.closest('.sc_btn_before')) {
    document.querySelector('.store_credit_wrapper').classList.add('sc_active');
    document.querySelector('#mini-cart').classList.add('sc_form_active');
  }
  if (event.target.closest('.sc_btn_after')) {
    document.querySelector('.store_credit_wrapper').classList.remove('sc_active');
    document.querySelector('#mini-cart').classList.remove('sc_form_active');
  }
});


// Cart upsell ABC test
document.addEventListener('DOMContentLoaded', function () {
  // Define <cart-recommendations> once
  if (!customElements.get('cart-recommendations')) {
    customElements.define(
      'cart-recommendations',
      class extends HTMLElement {
        connectedCallback() {
          const url =
            `${this.dataset.url}` +
            `&product_id=${this.dataset.productId}` +
            `&section_id=${this.dataset.sectionId}`;

          fetch(url)
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('cart-recommendations');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
            })
            .catch((e) => console.error('Cart recommendations error:', e));
        }

        addVariant(variantId) {
          fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
            }),
          })
            .then(() => {
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true })
              );
            })
            .catch((e) => console.error(e));
        }
      }
    );
  }

  (function () {
    'use strict';

    function refreshFlickityInPanel(panel) {
      if (!panel) return;

      const sliders = panel.querySelectorAll('.cart-upsell__products.flickity-enabled');

      sliders.forEach((slider) => {
        const flkty = Flickity.data(slider);
        if (!flkty) return;

        flkty.resize();
        flkty.reposition();
      });
    }

    document.addEventListener('click', function (event) {
      // TAB SWITCH
      var tab = event.target.closest('[data-upsell-tab]');
      if (tab) {
        var wrapper = tab.closest('[data-cart-upsell]');
        if (!wrapper) return;

        var targetId = tab.getAttribute('data-upsell-tab');

        wrapper.querySelectorAll('[data-upsell-tab]').forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });

        wrapper.querySelectorAll('.cart-upsell__panel').forEach(function (panel) {
          const isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);

          if (isActive) {
            requestAnimationFrame(function () {
              refreshFlickityInPanel(panel);
            });
          }
        });

        return;
      }

      // ADD TO CART
      var addBtn = event.target.closest('[data-upsell-add]');
      if (addBtn) {
        event.preventDefault();
        var variantId = Number(addBtn.getAttribute('data-variant-id'));
        if (!variantId) return;

        addBtn.disabled = true;
        addBtn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        })
          .then(function (res) {
            return res.json();
          })
          .then(function () {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
          })
          .catch(function (err) {
            console.error('Error adding upsell product:', err);
          })
          .finally(function () {
            addBtn.disabled = false;
            addBtn.classList.remove('is-loading');
          });
      }
    });
  })();
});

// ---- Flickity initialisation for upsell sliders ----
(function () {
  // Helper to init a single upsell slider
  function initUpsellSlider(slider) {
    if (!slider || !(slider instanceof HTMLElement)) return;

    // Already initialised? skip
    if (slider.classList.contains('upsell-flickity-initialized')) return;

    // Make sure Flickity is loaded
    if (typeof Flickity === 'undefined') {
      const retries = Number(slider.getAttribute('data-upsell-flickity-retries') || '0');
      if (retries > 10) {
        console.warn('Flickity not available for upsell slider after retries:', slider);
        return;
      }
      slider.setAttribute('data-upsell-flickity-retries', String(retries + 1));
      setTimeout(function () {
        initUpsellSlider(slider);
      }, 150);
      return;
    }


    var flkty = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      draggable: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: false,
      freeScroll: false,
      imagesLoaded: true,
    });

    function forceRefresh() {
      flkty.resize();
      flkty.reposition();
    }

    // Immediately after init
    requestAnimationFrame(forceRefresh);
    // And again after drawer animations / ajax are likely done
    setTimeout(forceRefresh, 300);

    slider.classList.add('upsell-flickity-initialized');
  }

  // 🔁 Refresh all existing Flickity instances (used when mini cart opens)
  function refreshAllUpsellSliders() {
    const sliders = document.querySelectorAll('.cart-upsell__products.flickity-enabled');
    sliders.forEach(function (slider) {
      var flkty = Flickity.data(slider);
      if (!flkty) return;
      flkty.resize();
      flkty.reposition();
    });
  }

  function initExistingUpsellSliders() {
    const sliders = document.querySelectorAll('.cart-upsell__products');
    sliders.forEach(initUpsellSlider);
  }

  function startObserver() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          // node itself
          if (node.matches('.cart-upsell__products')) {
            initUpsellSlider(node);
          }

          // nested nodes
          const nested = node.querySelectorAll
            ? node.querySelectorAll('.cart-upsell__products')
            : [];
          nested.forEach(initUpsellSlider);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function boot() {
    initExistingUpsellSliders();
    startObserver();

    // ✅ When cart is refreshed via AJAX
    document.documentElement.addEventListener('cart:refresh', function () {
      // give theme a moment to replace the drawer HTML
      setTimeout(function () {
        initExistingUpsellSliders();
        refreshAllUpsellSliders();
      }, 150);
    });

    // ✅ When user opens mini-cart via header icon / toggle
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('.header__cart-toggle,[data-action="toggle-mini-cart"]');
      if (!toggle) return;

      // Wait for drawer open animation, then refresh Flickity
      setTimeout(function () {
        refreshAllUpsellSliders();
      }, 300); // adjust if your drawer animation is longer/shorter
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    // DOM is already ready (script loaded late)
    boot();
  }
})();

// ------------ Start - Cart | Offer Kommunikation ------------

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.line-item-dd-btn');
  if (!btn) return;

  const parent = btn.closest('.line-item-dd-main');
  if (parent) {
    parent.classList.toggle('active_dd_item');
  }
});

// ------------ End - Cart | Offer Kommunikation ------------


document.addEventListener("DOMContentLoaded", function () {
  function triggerSearchOnMobile() {
    if (window.innerWidth < 640) {
      const searchBtn = document.querySelector(
        '.header__action-item-link[data-action="toggle-search"]'
      );

      if (searchBtn) {
        searchBtn.click();
      }
    }
  }

  triggerSearchOnMobile();
});